function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7-Copy",
  fill: "#E10009",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.0952381,7.78134729 C17.0492726,7.87525349 16.0942605,7.78134729 15.1392485,7.45267556 C15.0028182,7.40572246 14.8663879,7.45267556 14.7299577,7.49962867 C14.5935274,7.59353487 14.5480506,7.73439418 14.5480506,7.87525349 L14.5480506,17.3597803 C14.5480506,17.4067334 14.5480506,17.4536865 14.5025738,17.5006396 C14.27519,21.1629817 11.2737237,24.0740741 7.72627632,24.0740741 C3.95170501,24.0740741 0.904761905,20.9282162 0.904761905,17.0311086 C0.904761905,13.3687666 3.54241414,10.363768 7.04386501,10.0348279 L7.04386501,14.5892789 C5.99789947,14.9179507 5.2247945,15.9039658 5.2247945,17.0308403 C5.2247945,18.4394334 6.36171357,19.613261 7.72601645,19.613261 C8.95388905,19.613261 9.99985459,18.6741989 10.1817616,17.4534182 C10.2272384,17.4064651 10.2272384,17.3125589 10.2272384,17.2656058 L10.2272384,0.925925926 L14.0018097,0.925925926 C14.0927632,1.53631627 14.3201471,2.0528004 14.6384844,2.52233143 C15.4115894,3.6022528 16.7758922,4.16569004 18.0947184,3.83701832 L18.0952381,7.78134729 Z",
  id: "Shape"
}))));
function SvgTiktokIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "25px",
    viewBox: "0 0 19 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIconRed);
export default __webpack_public_path__ + "static/media/tiktok-icon--red.ceab753cac4bd089a6309abeccb1ee80.svg";
export { ForwardRef as ReactComponent };